const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const getDate = (date: Date) => {
	const month = months[date.getMonth()].slice(0, 3);
	const dateInMonth = date.getDate();
	const year = date.getFullYear();
	return `${month} ${dateInMonth}, ${year}`

}